// BASE
import { MainEntity } from 'interface';
import { BaseState } from './base';
import { OnboardingRole } from './onBoarding';

export type ProfileLinkingStatus = 'PENDING' | 'LINKED' | 'NOT_APPLICABLE';

export enum ProfileType {
  MySelf = 'MySelf',
  Nok = 'NOK'
}

// GET /profile - profile-service. Sourced from the LinkPass snapshot captured on the client's
// completed onboarding session, not the (possibly since-edited) mobileNumber.
export interface LinkPassData {
  phoneNumber?: string | null;
}

export interface User extends MainEntity {
  nric?: string;
  idType?: string;
  name: string;
  countryCode?: string;
  mobileNumber: string;
  homeNumber?: string | null;
  dateOfBirth: ParsableDate;
  gender: string;
  maritalStatus?: string;
  language?: string[] | string;
  otherLanguage?: string;
  religion?: string;
  otherReligion?: string;
  email: string;
  chasSubsidyTier?: string;
  chasExpiryDate?: ParsableDate;
  residentStatus?: string;
  nationality?: string;
  companyName?: string;
  otherResidentStatus?: string;
  marketingConsent?: boolean;
  unionMember?: boolean;
  unionNumber?: string;
  profileLinkingStatus?: ProfileLinkingStatus;
  admin?: boolean;
  selectedOnboardingRole?: OnboardingRole;
  linkPassData?: LinkPassData;
}

export interface UserState extends BaseState<User> {
  loggedInUser: User;
  profileUrl: string;
  personalDetailLoading: boolean;
}

export interface ProfileLinkingInput {
  referralCode: string;
  nric?: string;
  idType: string;
}

export interface ProfileLinkingParams {
  referralCode: string;
  linkingType: string;
  name?: string;
  email: string;
  mobilePhone: string;
  redirectedFromSvcRgn: boolean;
  nric: string;
}

export interface ProfileLinkingResponse {
  clientId: string;
  duplicateProfileFound: boolean;
  linkingType: string;
  lovedOneProfileMapped: boolean;
}

export interface ProfileResendCodeInput {
  nric?: string;
  type?: string;
  idType: string;
}

export interface ProfileResendCodeParams {
  nric: string;
  channel: string;
}

export interface CheckingProfile {
  user?: User;
  isNotFound: boolean;
}

// GET /profile/me/active-context - profile-service (BU-20814 / BU-20480)
// eGiro autofill context for the currently-selected profile.
export interface ActiveContextResponse {
  profileName: string;
  profileNric: string;
  // true when the logged-in user is the Client themselves; false when a NOK is applying for a dependent
  userIsClient: boolean;
  relationshipToCurrentUser?: string | null;
  // Free-text relationship label; present only when relationshipToCurrentUser = OTHER
  otherRelationship?: string | null;
}
